export const artistsDetailData = [
  {
    name: 'The Tokyo Echoes',
    genre: 'ロック / オルタナティブ',
    area: '渋谷区',
    activeYears: '2019年〜',
    icon: 'ri-music-2-line',
    description: '渋谷を拠点に活動する4人組ロックバンド。エモーショナルなメロディと力強いサウンドで、若い世代を中心に支持を集めています。月5回程度のライブ活動を継続中。',
    links: [
      { label: '公式サイト', url: 'https://example.com/tokyo-echoes', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_echoes', icon: 'ri-twitter-x-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_echoes', icon: 'ri-instagram-line' },
    ],
  },
  {
    name: 'Midnight Jazz Collective',
    genre: 'ジャズ / フュージョン',
    area: '港区',
    activeYears: '2017年〜',
    icon: 'ri-disc-line',
    description: '六本木を中心に活動するジャズコレクティブ。即興演奏を得意とし、毎回異なるセットリストで観客を魅了します。国内外のミュージシャンとのコラボレーションも積極的に行っています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/midnight-jazz', icon: 'ri-global-line' },
      { label: 'YouTube', url: 'https://youtube.com/example_jazz', icon: 'ri-youtube-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_jazz', icon: 'ri-instagram-line' },
    ],
  },
  {
    name: 'Sakura Acoustic',
    genre: 'アコースティック / フォーク',
    area: '豊島区',
    activeYears: '2020年〜',
    icon: 'ri-guitar-line',
    description: '池袋エリアで活動するシンガーソングライター。アコースティックギター1本で紡ぐ温かい歌声が特徴。カフェライブから大型会場まで幅広く出演しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/sakura-acoustic', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_sakura', icon: 'ri-twitter-x-line' },
      { label: 'Spotify', url: 'https://spotify.com/example_sakura', icon: 'ri-spotify-line' },
    ],
  },
  {
    name: 'Electric Pulse',
    genre: 'エレクトロニカ / テクノ',
    area: '千代田区',
    activeYears: '2018年〜',
    icon: 'ri-equalizer-line',
    description: '秋葉原を拠点とするエレクトロニックミュージックユニット。最新機材を駆使したライブパフォーマンスと、VJとのコラボレーションで独自の世界観を表現しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/electric-pulse', icon: 'ri-global-line' },
      { label: 'SoundCloud', url: 'https://soundcloud.com/example_pulse', icon: 'ri-soundcloud-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_pulse', icon: 'ri-instagram-line' },
    ],
  },
  {
    name: 'Shinjuku Soul Brothers',
    genre: 'R&B / ソウル',
    area: '新宿区',
    activeYears: '2016年〜',
    icon: 'ri-headphone-line',
    description: '新宿を拠点に活動する5人組ソウルバンド。70年代のクラシックソウルをベースに、現代的なアレンジを加えた楽曲で多くのファンを魅了しています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/soul-brothers', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_soul', icon: 'ri-twitter-x-line' },
      { label: 'YouTube', url: 'https://youtube.com/example_soul', icon: 'ri-youtube-line' },
    ],
  },
  {
    name: 'Harajuku Pop Stars',
    genre: 'ポップス / J-POP',
    area: '渋谷区',
    activeYears: '2021年〜',
    icon: 'ri-star-line',
    description: '原宿発の3人組ポップユニット。キャッチーなメロディと華やかなステージングで、若い世代を中心に急速にファンを増やしています。SNSでの発信も積極的に行っています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/harajuku-pop', icon: 'ri-global-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_harajuku', icon: 'ri-instagram-line' },
      { label: 'TikTok', url: 'https://tiktok.com/@example_harajuku', icon: 'ri-tiktok-line' },
    ],
  },
  {
    name: 'Underground Noise',
    genre: 'パンク / ハードコア',
    area: '世田谷区',
    activeYears: '2015年〜',
    icon: 'ri-fire-line',
    description: '下北沢のライブハウスシーンを牽引するパンクバンド。激しいサウンドと社会派なメッセージで、コアなファン層から絶大な支持を得ています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/underground-noise', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_noise', icon: 'ri-twitter-x-line' },
      { label: 'Bandcamp', url: 'https://bandcamp.com/example_noise', icon: 'ri-album-line' },
    ],
  },
  {
    name: 'Koenji Reggae Crew',
    genre: 'レゲエ / ダブ',
    area: '杉並区',
    activeYears: '2019年〜',
    icon: 'ri-rhythm-line',
    description: '高円寺を拠点とするレゲエクルー。本場ジャマイカのサウンドを継承しつつ、日本語詞で独自のスタイルを確立。フェスやクラブイベントでも活躍中。',
    links: [
      { label: '公式サイト', url: 'https://example.com/koenji-reggae', icon: 'ri-global-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_reggae', icon: 'ri-instagram-line' },
      { label: 'YouTube', url: 'https://youtube.com/example_reggae', icon: 'ri-youtube-line' },
    ],
  },
  {
    name: 'Neon Dreams',
    genre: 'シンセポップ / ニューウェーブ',
    area: '渋谷区',
    activeYears: '2020年〜',
    icon: 'ri-flashlight-line',
    description: '80年代のシンセポップにインスパイアされたサウンドで注目を集める2人組ユニット。レトロとモダンが融合した独特の世界観が特徴です。',
    links: [
      { label: '公式サイト', url: 'https://example.com/neon-dreams', icon: 'ri-global-line' },
      { label: 'Spotify', url: 'https://spotify.com/example_neon', icon: 'ri-spotify-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_neon', icon: 'ri-instagram-line' },
    ],
  },
  {
    name: 'Tokyo Brass Ensemble',
    genre: 'ブラス / ファンク',
    area: '新宿区',
    activeYears: '2017年〜',
    icon: 'ri-music-line',
    description: '管楽器を中心とした8人編成のブラスアンサンブル。ファンクやジャズをベースに、ダンサブルなサウンドでフロアを盛り上げます。結婚式やイベント出演も多数。',
    links: [
      { label: '公式サイト', url: 'https://example.com/brass-ensemble', icon: 'ri-global-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_brass', icon: 'ri-twitter-x-line' },
      { label: 'YouTube', url: 'https://youtube.com/example_brass', icon: 'ri-youtube-line' },
    ],
  },
  {
    name: 'Indie Cats',
    genre: 'インディーロック / オルタナティブ',
    area: '世田谷区',
    activeYears: '2021年〜',
    icon: 'ri-contrast-2-line',
    description: '下北沢発の若手インディーロックバンド。実験的なサウンドと詩的な歌詞で、インディーシーンで急速に注目を集めています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/indie-cats', icon: 'ri-global-line' },
      { label: 'Bandcamp', url: 'https://bandcamp.com/example_cats', icon: 'ri-album-line' },
      { label: 'Instagram', url: 'https://instagram.com/example_cats', icon: 'ri-instagram-line' },
    ],
  },
  {
    name: 'Vocal Harmony Project',
    genre: 'アカペラ / ボーカルグループ',
    area: '豊島区',
    activeYears: '2018年〜',
    icon: 'ri-mic-line',
    description: '楽器を使わず、声だけで音楽を奏でる6人組アカペラグループ。ポップスからジャズまで幅広いレパートリーで、美しいハーモニーを届けています。',
    links: [
      { label: '公式サイト', url: 'https://example.com/vocal-harmony', icon: 'ri-global-line' },
      { label: 'YouTube', url: 'https://youtube.com/example_vocal', icon: 'ri-youtube-line' },
      { label: 'X (Twitter)', url: 'https://x.com/example_vocal', icon: 'ri-twitter-x-line' },
    ],
  },
];
